<template>
  <div class="bottom-panel" :class="{ expanded }">
    <div class="container" @click="expanded = !expanded">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      expanded: false
    }
  }
}
</script>

<style lang="scss" scoped>
.bottom-panel {
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 100px;
  z-index: 1000;
  overflow: auto;
  background-color: white;
  border-radius: 24px 24px 0 0;
  box-shadow: 18px rgb(0 0 0 / 26%);
  &.expanded {
    height: 60%;
  }
  .container {
    position: relative;
    .close-button {
      position: absolute;
      top: 20px;
      right: 60px;
      width: 40px;
      height: 40px;
      z-index: 100;
      background-color: white;
      // border: 1px solid black;
    }
  }
}
</style>
